import React from 'react';
import {
  Show,
  TabbedShowLayout,
  TextField,
  BooleanField,
  ReferenceField,
  ReferenceManyField, Datagrid,
  Tab,
} from 'react-admin';

import ReglaConfiguracionDeTope from './ReglaConfiguracionDeTope';
import ReglaConfiguracionGeneral from './ReglaConfiguracionGeneral';
import SgxDateField from '../components/sgxDateField';

const ReglaShow = (props) => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="resources.regla.tabs.general">
        <TextField source="descripcion" />
        <TextField source="descripcionCompleta" />
        <TextField source="nroTicket" />
        <TextField source="idCodigoRechazo" />
        <ReferenceField source="idTipoRegla" reference="tipos-regla" link={false}>
          <TextField source="descripcion" />
        </ReferenceField>
        <ReferenceField source="idGrupoRegla" reference="grupo-regla">
          <TextField source="descripcion" />
        </ReferenceField>
        <ReferenceField source="estado" reference="estado-regla" link={false}>
          <TextField source="descripcion" />
        </ReferenceField>
        <SgxDateField source="desde" label="resources.regla.fields.desde"  />
        <SgxDateField source="hasta" label="resources.regla.fields.hasta" />
      </Tab>
      <Tab label="resources.regla.tabs.configuraciones">
        <ReglaConfiguracionDeTope />
        <ReglaConfiguracionGeneral />
      </Tab>
      <Tab label="resources.regla.tabs.excepciones">
        <ReferenceManyField
          addLabel={false}
          reference="excepciones"
          target="idRegla"
          sort={{ field: 'idPrestacion', order: 'DESC' }}
          filter={{ deleted: false }}
        >
          <Datagrid rowClick={null}>
            <TextField source="idPrestacion" />
            <ReferenceField label="resources.prestaciones.fields.descripcion" source="idPrestacion" reference="prestaciones" link={false}>
              <TextField source="descripcion" />
            </ReferenceField>
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="resources.regla.tabs.tipo-transaccion">
        <ReferenceManyField
          addLabel={false}
          reference="regla-tipo-transaccion"
          target="idRegla"
          sort={{ field: 'idTipoTransaccion', order: 'DESC' }}
          filter={{ deleted: false }}
        >
          <Datagrid rowClick="show">
            <TextField source="idTipoTransaccion" />
            <ReferenceField label="resources.tipos-transaccion.fields.descripcion" source="idTipoTransaccion" reference="tipos-transaccion" link={false}>
              <TextField source="descripcion" />
            </ReferenceField>
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="resources.regla.tabs.etiquetas" path="etiquetas">
        <ReferenceManyField
          addLabel={false}
          reference="regla-etiqueta"
          target="idRegla"
        >
          <Datagrid>
            <TextField source="idEtiqueta" label="resources.regla-etiqueta.fields.idEtiqueta" />
            <ReferenceField label="resources.etiqueta.fields.descripcion" source="idEtiqueta" reference="etiquetas" link={false}>
              <TextField source="descripcion" />
            </ReferenceField>
            <BooleanField source="excluye" label="resources.regla-etiqueta.fields.excluye" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export default ReglaShow;
